import type { Location } from '../types';

/**
 * Predefined landmark locations including world wonders, famous towers, natural landmarks, and cultural sites
 */
export const LANDMARKS: Location[] = [
  // Seven Wonders of the Modern World
  {
    id: 'landmark-1',
    name: 'Great Wall of China',
    coordinates: { lat: 40.4319, lng: 116.5704 },
    country: 'China',
    description: 'An ancient series of walls and fortifications built across northern China.',
    images: [],
    category: 'World Wonder',
    isLandmark: true,
  },
  {
    id: 'landmark-2',
    name: 'Petra',
    coordinates: { lat: 30.3285, lng: 35.4444 },
    country: 'Jordan',
    description: 'An archaeological city famous for its rock-cut architecture and water conduit system.',
    images: [],
    category: 'World Wonder',
    isLandmark: true,
  },
  {
    id: 'landmark-3',
    name: 'Christ the Redeemer',
    coordinates: { lat: -22.9519, lng: -43.2105 },
    country: 'Brazil',
    description: 'An Art Deco statue of Jesus Christ in Rio de Janeiro.',
    images: [],
    category: 'World Wonder',
    isLandmark: true,
  },
  {
    id: 'landmark-4',
    name: 'Machu Picchu',
    coordinates: { lat: -13.1631, lng: -72.5450 },
    country: 'Peru',
    description: 'A 15th-century Inca citadel set high in the Andes Mountains.',
    images: [],
    category: 'World Wonder',
    isLandmark: true,
  },
  {
    id: 'landmark-5',
    name: 'Chichen Itza',
    coordinates: { lat: 20.6843, lng: -88.5678 },
    country: 'Mexico',
    description: 'A large pre-Columbian archaeological site built by the Maya civilization.',
    images: [],
    category: 'World Wonder',
    isLandmark: true,
  },
  {
    id: 'landmark-6',
    name: 'Roman Colosseum',
    coordinates: { lat: 41.8902, lng: 12.4922 },
    country: 'Italy',
    description: 'An oval amphitheatre in the centre of Rome, the largest ancient amphitheatre ever built.',
    images: [],
    category: 'World Wonder',
    isLandmark: true,
  },
  {
    id: 'landmark-7',
    name: 'Taj Mahal',
    coordinates: { lat: 27.1751, lng: 78.0421 },
    country: 'India',
    description: 'An ivory-white marble mausoleum on the right bank of the river Yamuna.',
    images: [],
    category: 'World Wonder',
    isLandmark: true,
  },
  // Famous Towers
  {
    id: 'landmark-8',
    name: 'Eiffel Tower',
    coordinates: { lat: 48.8584, lng: 2.2945 },
    country: 'France',
    description: 'A wrought-iron lattice tower on the Champ de Mars in Paris.',
    images: [],
    category: 'Famous Tower',
    isLandmark: true,
  },
  {
    id: 'landmark-9',
    name: 'Statue of Liberty',
    coordinates: { lat: 40.6892, lng: -74.0445 },
    country: 'United States',
    description: 'A colossal neoclassical sculpture on Liberty Island in New York Harbor.',
    images: [],
    category: 'Famous Tower',
    isLandmark: true,
  },
  {
    id: 'landmark-10',
    name: 'Big Ben',
    coordinates: { lat: 51.5007, lng: -0.1246 },
    country: 'United Kingdom',
    description: 'The nickname for the Great Bell of the Great Clock of Westminster.',
    images: [],
    category: 'Famous Tower',
    isLandmark: true,
  },
  {
    id: 'landmark-11',
    name: 'Burj Khalifa',
    coordinates: { lat: 25.1972, lng: 55.2744 },
    country: 'United Arab Emirates',
    description: 'The tallest structure and building in the world since 2009.',
    images: [],
    category: 'Famous Tower',
    isLandmark: true,
  },
  {
    id: 'landmark-12',
    name: 'Tokyo Tower',
    coordinates: { lat: 35.6586, lng: 139.7454 },
    country: 'Japan',
    description: 'A communications and observation tower in the Shiba-koen district of Minato, Tokyo.',
    images: [],
    category: 'Famous Tower',
    isLandmark: true,
  },
  // Natural Landmarks
  {
    id: 'landmark-13',
    name: 'Grand Canyon',
    coordinates: { lat: 36.0544, lng: -112.1401 },
    country: 'United States',
    description: 'A steep-sided canyon carved by the Colorado River in Arizona.',
    images: [],
    category: 'Natural Landmark',
    isLandmark: true,
  },
  {
    id: 'landmark-14',
    name: 'Great Barrier Reef',
    coordinates: { lat: -18.2871, lng: 147.6992 },
    country: 'Australia',
    description: 'The world\'s largest coral reef system composed of over 2,900 individual reefs.',
    images: [],
    category: 'Natural Landmark',
    isLandmark: true,
  },
  {
    id: 'landmark-15',
    name: 'Victoria Falls',
    coordinates: { lat: -17.9243, lng: 25.8572 },
    country: 'Zambia/Zimbabwe',
    description: 'A waterfall on the Zambezi River in southern Africa.',
    images: [],
    category: 'Natural Landmark',
    isLandmark: true,
  },
  {
    id: 'landmark-16',
    name: 'Mount Everest',
    coordinates: { lat: 27.9881, lng: 86.9250 },
    country: 'Nepal/Tibet',
    description: 'Earth\'s highest mountain above sea level.',
    images: [],
    category: 'Natural Landmark',
    isLandmark: true,
  },
  {
    id: 'landmark-17',
    name: 'Northern Lights viewing area',
    coordinates: { lat: 68.4380, lng: 17.4260 },
    country: 'Norway',
    description: 'Natural light display in Earth\'s sky, predominantly seen in high-latitude regions.',
    images: [],
    category: 'Natural Landmark',
    isLandmark: true,
  },
  {
    id: 'landmark-18',
    name: 'Amazon Rainforest',
    coordinates: { lat: -3.4653, lng: -62.2159 },
    country: 'Brazil',
    description: 'A moist broadleaf tropical rainforest in the Amazon biome.',
    images: [],
    category: 'Natural Landmark',
    isLandmark: true,
  },
  // Cultural Sites
  {
    id: 'landmark-19',
    name: 'Pyramids of Giza',
    coordinates: { lat: 29.9792, lng: 31.1342 },
    country: 'Egypt',
    description: 'Ancient pyramid complex including the Great Pyramid and the Sphinx.',
    images: [],
    category: 'Cultural Site',
    isLandmark: true,
  },
  {
    id: 'landmark-20',
    name: 'Angkor Wat',
    coordinates: { lat: 13.4125, lng: 103.8670 },
    country: 'Cambodia',
    description: 'A temple complex and the largest religious monument in the world.',
    images: [],
    category: 'Cultural Site',
    isLandmark: true,
  },
  {
    id: 'landmark-21',
    name: 'Acropolis of Athens',
    coordinates: { lat: 37.9715, lng: 23.7257 },
    country: 'Greece',
    description: 'An ancient citadel located on a rocky outcrop above the city of Athens.',
    images: [],
    category: 'Cultural Site',
    isLandmark: true,
  },
  {
    id: 'landmark-22',
    name: 'Stonehenge',
    coordinates: { lat: 51.1789, lng: -1.8262 },
    country: 'United Kingdom',
    description: 'A prehistoric monument consisting of a ring of standing stones.',
    images: [],
    category: 'Cultural Site',
    isLandmark: true,
  },
  {
    id: 'landmark-23',
    name: 'Forbidden City',
    coordinates: { lat: 39.9163, lng: 116.3972 },
    country: 'China',
    description: 'A palace complex in central Beijing that was the Chinese imperial palace.',
    images: [],
    category: 'Cultural Site',
    isLandmark: true,
  },
  {
    id: 'landmark-24',
    name: 'Sagrada Familia',
    coordinates: { lat: 41.4036, lng: 2.1744 },
    country: 'Spain',
    description: 'A large unfinished Roman Catholic minor basilica in Barcelona designed by Antoni Gaud�.',
    images: [],
    category: 'Cultural Site',
    isLandmark: true,
  },
  {
    id: 'landmark-25',
    name: 'Santorini',
    coordinates: { lat: 36.3932, lng: 25.4615 },
    country: 'Greece',
    description: 'A Greek island in the southern Aegean Sea, known for its dramatic views.',
    images: [],
    category: 'Cultural Site',
    isLandmark: true,
  },
  {
    id: 'landmark-26',
    name: 'Sydney Opera House',
    coordinates: { lat: -33.8568, lng: 151.2153 },
    country: 'Australia',
    description: 'A multi-venue performing arts centre in Sydney, a masterpiece of architecture.',
    images: [],
    category: 'Cultural Site',
    isLandmark: true,
  },
  {
    id: 'landmark-27',
    name: 'Neuschwanstein Castle',
    coordinates: { lat: 47.5576, lng: 10.7498 },
    country: 'Germany',
    description: 'A 19th-century Romanesque Revival palace on a rugged hill in Bavaria.',
    images: [],
    category: 'Cultural Site',
    isLandmark: true,
  },
  {
    id: 'landmark-28',
    name: 'Alhambra',
    coordinates: { lat: 37.1761, lng: -3.5881 },
    country: 'Spain',
    description: 'A palace and fortress complex located in Granada, Andalusia.',
    images: [],
    category: 'Cultural Site',
    isLandmark: true,
  },
];
